/**
 * @generated SignedSource<<be6ba3a4d7488b5ecbbd64db4ea41b37>>
 * @relayHash 028bc8cd44ccfe555825b862cac7175f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceRefreshSmartSpaceOverviewInput = {
  spaceKey: string;
  topLinks?: ConfluenceRefreshTopLinksInput | null | undefined;
};
export type ConfluenceRefreshTopLinksInput = {
  overridePinned?: boolean | null | undefined;
};
export type TopLinksCardRefreshTopLinksMutation$variables = {
  cloudId: string;
  input: ConfluenceRefreshSmartSpaceOverviewInput;
};
export type TopLinksCardRefreshTopLinksMutation$data = {
  readonly confluence_refreshSmartSpaceOverview: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly overview: {
      readonly topLinks: {
        readonly contentId: string | null | undefined;
        readonly lastRefreshed: AGG$DateTime | null | undefined;
        readonly links: ReadonlyArray<{
          readonly isPinned: boolean | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type TopLinksCardRefreshTopLinksMutation = {
  response: TopLinksCardRefreshTopLinksMutation$data;
  variables: TopLinksCardRefreshTopLinksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
    "kind": "LinkedField",
    "name": "confluence_refreshSmartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverview",
        "kind": "LinkedField",
        "name": "overview",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
            "kind": "LinkedField",
            "name": "topLinks",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "contentId"
              },
              {
                "kind": "ScalarField",
                "name": "lastRefreshed"
              },
              {
                "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isPinned"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopLinksCardRefreshTopLinksMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopLinksCardRefreshTopLinksMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "028bc8cd44ccfe555825b862cac7175f",
    "id": "2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9",
    "metadata": {},
    "name": "TopLinksCardRefreshTopLinksMutation",
    "operationKind": "mutation",
    "text": "mutation TopLinksCardRefreshTopLinksMutation($cloudId:ID!,$input:ConfluenceRefreshSmartSpaceOverviewInput!){confluence_refreshSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
  }
};
})();

(node as any).hash = "8e825f319472bd53e49e1decd81de040";

export default node;
